import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import List from './Documents'
import Detail from './DocumentDetail'

import { getLocation } from 'ducks/router'

const getPk = R.pipe(
  getLocation,
  R.propOr({}, 'payload'),
  R.pick(['pk']),
)

const Documents = ({ pk }) => {
  return pk ? <Detail pk={pk} /> : <List />
}

export default connect(getPk)(Documents)
